@let form = block();
@let images = form.controls.accessibleImages;
<div
  [formGroup]="form"
  class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
  <div class="text-standard-text-secondary pt-3 pl-8 text-sm font-semibold">
    {{ cmsTextProvider.footer.links }}
  </div>
  <div class="flex min-w-0 flex-col gap-4">
    <div class="w-60">
      <aw-button-group
        [id]="'block-orientation-' + index()"
        [compact]="true"
        [options]="orientationOptions"
        [formControl]="form.controls.orientation" />
    </div>
    @for (image of images.controls; track image; let imageIndex = $index) {
      <div class="flex items-start gap-4">
        <div class="flex min-h-12 flex-col items-center justify-center">
          <button
            type="button"
            class="text-info-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
            [disabled]="imageIndex === 0"
            [attr.aria-label]="
              'Bild ' + (imageIndex + 1) + ' nach oben verschieben'
            "
            (click)="moveImage(imageIndex, -1)">
            <span class="material-symbols-rounded text-xl!" aria-hidden="true"
              >keyboard_arrow_up</span
            >
          </button>
          <button
            type="button"
            class="text-info-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
            [disabled]="imageIndex === images.length - 1"
            [attr.aria-label]="
              'Bild ' + (imageIndex + 1) + ' nach unten verschieben'
            "
            (click)="moveImage(imageIndex, 1)">
            <span class="material-symbols-rounded text-xl!" aria-hidden="true"
              >keyboard_arrow_down</span
            >
          </button>
        </div>
        <div class="grid min-w-0 flex-1 grid-cols-1 gap-4 lg:grid-cols-3">
          <aw-image-select
            [id]="'block-image-' + index() + '-' + imageIndex"
            [formControl]="image.controls.image"
            [label]="cmsTextProvider.footer.imageSource" />
          <aw-translation-accessibility-text-input
            [entityType]="EntityType.footerPaymentArea"
            [relationType]="TextRelationType.imageAlt"
            [id]="'block-image-alt-' + index() + '-' + imageIndex"
            [formControl]="image.controls.imageAlts"
            [label]="cmsTextProvider.footer.description" />
          <aw-text-input
            [id]="'block-image-url-' + index() + '-' + imageIndex"
            [formControl]="image.controls.url"
            [label]="cmsTextProvider.footer.linkAddressLabel" />
        </div>
        <aw-button
          class="block w-12 shrink-0 [&>button]:h-12! [&>button]:w-12! [&>button]:p-0!"
          [id]="'delete-block-image-' + index() + '-' + imageIndex"
          type="button"
          [style]="'error-alt'"
          buttonSize="quadratic"
          (click)="removeImage(imageIndex)">
          <span class="material-symbols-rounded text-xl!" aria-hidden="true"
            >delete</span
          >
          <span class="sr-only">{{ cmsTextProvider.shared.delete }}</span>
        </aw-button>
      </div>
    }
    <aw-button
      class="blue w-fit [&>button]:text-sm [&>button]:text-[#0066CC]!"
      [id]="'add-block-image-' + index()"
      type="button"
      [style]="'primary-alt'"
      buttonSize="small"
      (click)="addImage()">
      <span class="material-symbols-rounded mr-1 text-base!" aria-hidden="true"
      >add</span
      >
      {{ cmsTextProvider.shared.add }}
    </aw-button>
  </div>
</div>
